import { ITableRes, ITeacher, ITeacherParams } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const teachersAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_teachers: builder.query<ITableRes<ITeacher>, ITeacherParams>({
      query: (params) => ({
       url: '/teachers/',
       params: params
      }),
      providesTags: ['teachers'],
    }),
    // CRUD operations
    GET_teacherById: builder.query<ITeacher, string>({
      query: (id) => {
        return {
          url: `/teachers/${id}/`,
        }
      },
      providesTags: ['teacher'],
      transformResponse: (response: ITeacher): any => {
        return {
          ...response,
         subjects: response.teacher_profile.subjects
        }
      },
    }),
    POST_teacher: builder.mutation<ITeacher, ITeacher>({
      query: (body) => ({
        url: `/teachers/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['teachers'],
    }),
    PUT_teacher: builder.mutation<ITeacher, { id: string; body: ITeacher }>({
      query: ({ id, body }) => ({
        url: `/teachers/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['teachers', 'teacher'],
    }),
    DELETE_teacher: builder.mutation<ITeacher, string>({
      query: (id) => ({
        url: `/teachers/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['teachers'],
    }),
    // Selects
    GET_teacherProfileSelect: builder.query<any, {group_course: number}>({
      query: (params) => ({
        url: '/teachers/profile/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['teacher-profile-select'],
    }),
  }),
})

export const {
  useGET_teachersQuery,
  useGET_teacherByIdQuery,
  usePOST_teacherMutation,
  usePUT_teacherMutation,
  useDELETE_teacherMutation,
  useGET_teacherProfileSelectQuery,
} = teachersAPI
